import { ofType } from 'redux-observable';
import { mergeMap, debounceTime } from 'rxjs/operators';
import { merge, of } from 'rxjs';

import { EXPORT_SINGLE_CLIENT_REPORT_PDF } from '../../types';
import { EXPORT_SINGLE_CLIENT_REPORT_PDF_MESSAGES } from '../../constants/exportSingleClientReportPdfContants';
import { exportSingleClientReportPdfPending, exportSingleClientReportPdfFulfilled, exportSingleClientReportPdfRejected } from '../../actions';
import { sendApiRequest, notifyError, notifyWarning } from '../../../../actions';
import generateError from '../../../../utilities/generateError';

const createPayload = payload => ({
  method: 'get',
  url: 'report/GetSingleClientReportPdf',
  onSuccess: [response => (response.data.length === 0
    ? notifyWarning(EXPORT_SINGLE_CLIENT_REPORT_PDF_MESSAGES.NOT_FOUND)
    : exportSingleClientReportPdfFulfilled(response))],
  onError: [
    exportSingleClientReportPdfRejected,
    error => notifyError(generateError(error)),
  ],
  data: payload,
});
const meta = {
  api: 'pdfApi',
};

const exportSingleClientReportEpic$ = action$ => action$.pipe(
  ofType(EXPORT_SINGLE_CLIENT_REPORT_PDF.DEFAULT),
  debounceTime(500),
  mergeMap(({ payload }) => merge(
    of(exportSingleClientReportPdfPending()),
    of(sendApiRequest(createPayload(payload), meta)),
  )),
);

export default exportSingleClientReportEpic$;


// WEBPACK FOOTER //
// ./src/features/reports/epics/single-client/exportSingleClientReportPdfEpic.js